import router from '@/router/router'

export default router



// WEBPACK FOOTER //
// ./src/router/index.js